  <template>
    <ScrollUp :type="ctaVariant" />
    <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
      <BlokkliField :list="paragraphs" name="field_paragraphs" />
    </BlokkliProvider>

    <LocationSearch v-if="showLocationSearch" :title="titleContent" :subline="sublineContent" :text="textContent" />
  </template>

<script lang="ts" setup>
import type { NodePageFragment } from '#graphql-operations'

const { $texts } = useNuxtApp()

const props = defineProps<{
  uuid: string
  title?: string
  lead?: string
  paragraphs?: NodePageFragment['paragraphs']
  body?: string
  blokkliProps: NodePageFragment['blokkliProps']
  showLocationSearch?: boolean
  isFrontpage?: boolean
  ctaVariant?: string
}>()

if (props?.isFrontpage) {
  useHead({
    htmlAttrs: {
      class: 'home',
    },
  });
}

const titleContent = computed(() => $texts('location_search.title', 'Standort suchen'))
const sublineContent = computed(() => $texts('location_search.lead', 'Finden Sie Ihren Ansprechpartner in Ihrer Nähe'))
const textContent = computed(() => $texts('location_search.text', 'Geben Sie Ihren Standort ein, um Ihren Ansprechpartner in Ihrer Nähe zu finden'))
</script>
